import { Tabs } from 'antd';
import React,{useState} from 'react';
import { AllCatogries } from './AllCatogries';
import styles from './course.module.css';
import { AiDetails } from './AiDetails';
import { CncDetails } from './CncDetails';
import { BcDetails } from './BcDetails';
import { IotDetails } from './IotDetails';
const { TabPane } = Tabs;



export function NavButton  ()  {
            const [radioSize] = useState({ size: 'large' });
           
              const {size} = radioSize;
              
    return (
        <div>
        <Tabs defaultActiveKey="1" type="card" size={size} >
          <TabPane tab="All Catogries" key="1" className={styles.courses_tab}>
          <AllCatogries/>
          </TabPane>
          <TabPane tab="A I" key="2">
           <AiDetails/>
          </TabPane>
          <TabPane tab="C N C" key="3">
           <CncDetails/>
          </TabPane>
          <TabPane tab="B C" key="4">
            <BcDetails/>
          </TabPane>
          <TabPane tab="I o T" key="5">
            <IotDetails/>
          </TabPane>
         
        </Tabs>
      </div>
    );
}